const PageHeader = ({ title, eyebrow = 'PT Len Telekomunikasi Indonesia' }) => {
    return (
        <header
            className="page-header relative mt-20 flex min-h-[170px] items-end overflow-hidden bg-cover bg-center sm:min-h-[210px]"
            style={{
                backgroundImage: "url('/assets-web/banner-footer.png')",
                backgroundPosition: 'center 19%',
            }}
        >
            <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-[#06264a]/65" />
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_15%,rgba(59,130,246,0.20),transparent_32%)]" />
            <div className="container relative z-10 mx-auto max-w-[1480px] px-5 pb-8 pt-12 sm:px-8 sm:pb-10">
                <span className="text-[10px] font-semibold uppercase tracking-[0.26em] text-blue-300 sm:text-xs">
                    {eyebrow}
                </span>
                <div className="mt-2 flex items-end gap-4">
                    <div className="h-10 w-1 flex-none rounded-full bg-blue-500 sm:h-12" />
                    <h1 className="break-words text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        {title}
                    </h1>
                </div>
            </div>
        </header>
    );
};

export default PageHeader;
